
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

const CreateHotTaskModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean,
    taskTypes: Array,
    learningVectorHistId: Number,
    userId: Number
  }
})

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component
export default class CreateHotTaskModal extends CreateHotTaskModalProps {
  data () {
    return {
      isLoading: false,
      selectedType: null,
      isFormValid: false
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['selectedType'], function () {
      this.validateForm()
    })
  }

  validateForm () {
    this.isFormValid = this.$refs.form.checkValidity() && this.selectedType !== ''
  }

  async createHotTask () {
    try {
      this.isLoading = true

      var resp
      if (this.learningVectorHistId) {
        var data = {
          taskType: this.selectedType,
          learningVectorHistId: this.learningVectorHistId
        }
        resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/createTask/${this.userId}`, data)
      } else {
        resp = await FetchWrapper.get(`${process.env.VUE_APP_SERVERURL}/createHotTask/${this.userId}/${this.selectedType}`)
      }
      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Task created Successfully',
          onConfirm: () => {
            this.$emit('created', resp.id)
            this.$emit('close')
            this.selectedType = null
          },
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
